/* grillion-products.js - Product carousel slider and cart interactions for Grillion */

(function() {
  function initGrillionProducts() {
    const sections = document.querySelectorAll('.grillion-products-section');
    sections.forEach(section => {
      if (section.dataset.grillionInitialized === 'true') return;
      section.dataset.grillionInitialized = 'true';

      const trackContainer = section.querySelector('.grillion-products-track-container');
      const track = section.querySelector('.grillion-products-track');
      if (!trackContainer || !track || track.classList.contains('layout-grid')) return;

      const prevBtn = section.querySelector('.grillion-products-nav-btn.prev-btn');
      const nextBtn = section.querySelector('.grillion-products-nav-btn.next-btn');
      const cards = track.querySelectorAll('.product-card');
      if (cards.length === 0) return;

      let currentIndex = 0;
      let cardWidth = 0;
      let gap = 24;

      function getVisibleCardsCount() {
        const width = window.innerWidth;
        if (width >= 1200) return 4;
        if (width >= 992) return 3;
        if (width >= 576) return 2;
        return 1;
      }

      let containerWidth = 0;
      let appliedKey = '';

      function calculateDimensions() {
        // Fallback read only when ResizeObserver hasn't supplied a width yet.
        if (!containerWidth) containerWidth = trackContainer.offsetWidth;
        const visibleCount = getVisibleCardsCount();
        gap = window.innerWidth <= 768 ? 16 : 24;
        
        // Calculate each card width dynamically to fill container cleanly
        const totalGaps = (visibleCount - 1) * gap;
        cardWidth = (containerWidth - totalGaps) / visibleCount;

        // Skip DOM writes when nothing changed (avoids repeated style/layout work).
        const key = `${cardWidth}|${gap}`;
        if (key === appliedKey) return;
        appliedKey = key;

        cards.forEach(card => {
          card.style.flex = `0 0 ${cardWidth}px`;
          card.style.width = `${cardWidth}px`;
        });

        track.style.gap = `${gap}px`;
      }

      function getMaxIndex() {
        const visibleCount = getVisibleCardsCount();
        return Math.max(0, cards.length - visibleCount);
      }

      function updateCarousel(animate = true) {
        calculateDimensions();
        const maxIndex = getMaxIndex();

        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        if (currentIndex < 0) {
          currentIndex = 0;
        }

        const slideAmount = cardWidth + gap;
        const offset = -currentIndex * slideAmount;

        if (!animate) {
          track.style.transition = 'none';
        } else {
          track.style.transition = 'transform 0.45s cubic-bezier(0.16, 1, 0.3, 1)';
        }

        track.style.transform = `translateX(${offset}px)`;

        // Update navigation button states
        if (prevBtn) {
          if (currentIndex === 0) {
            prevBtn.classList.add('disabled');
            prevBtn.setAttribute('disabled', 'disabled');
          } else {
            prevBtn.classList.remove('disabled');
            prevBtn.removeAttribute('disabled');
          }
        }

        if (nextBtn) {
          if (currentIndex >= maxIndex) {
            nextBtn.classList.add('disabled');
            nextBtn.setAttribute('disabled', 'disabled');
          } else {
            nextBtn.classList.remove('disabled');
            nextBtn.removeAttribute('disabled');
          }
        }
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const maxIndex = getMaxIndex();
          if (currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel(true);
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (currentIndex > 0) {
            currentIndex--;
            updateCarousel(true);
          }
        });
      }

      // Touch / Swipe support
      let startX = 0;
      let currentX = 0;
      let isSwiping = false;

      trackContainer.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        currentX = startX;
        isSwiping = true;
      }, { passive: true });

      trackContainer.addEventListener('touchmove', (e) => {
        if (!isSwiping) return;
        currentX = e.touches[0].clientX;
      }, { passive: true });

      trackContainer.addEventListener('touchend', () => {
        if (!isSwiping) return;
        isSwiping = false;
        const diffX = startX - currentX;
        const threshold = 40;

        if (diffX > threshold) {
          // Swipe left -> Next
          const maxIndex = getMaxIndex();
          if (currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel(true);
          }
        } else if (diffX < -threshold) {
          // Swipe right -> Prev
          if (currentIndex > 0) {
            currentIndex--;
            updateCarousel(true);
          }
        }
      });

      if ('ResizeObserver' in window) {
        // Perf: the observer delivers the container width after layout, so no forced reflow on load.
        const ro = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (!width) return;
          containerWidth = width;
          updateCarousel(false);
        });
        ro.observe(trackContainer);
      } else {
        window.addEventListener('resize', () => {
          containerWidth = 0;
          updateCarousel(false);
        }, { passive: true });
        requestAnimationFrame(() => updateCarousel(false));
      }
    });
  }

  // Handle Add to Cart interactions
  function initGrillionAddToCart() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.grillion-products-section .add-to-cart-trigger');
      if (!btn || btn.disabled) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.innerHTML = '<span>Redirecting...</span>';

      const payload = {
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: 1
          }
        ]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add item to cart');
          });
        }
        return res.json();
      })
      .then(data => {
        window.location.href = '/checkout';
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
        window.location.href = `/cart/${variantId}:1`;
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGrillionProducts();
      initGrillionAddToCart();
    });
  } else {
    initGrillionProducts();
    initGrillionAddToCart();
  }

  // Theme Editor section reload support
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.grillion-products-section')) {
      initGrillionProducts();
    }
  });
})();
